import workflow from '@banking/ui/lib/workflow';
import { ActionType, handleRetrieveBitcoinAccountResponseAction, handleRetrieveBitcoinAccountRequestAction } from './actions';
export * from './actions';
export * from './selectors';

// State
// =============================================================================

export const INITIAL_STATE = {
  accountEligibility: undefined,
  btcAccount: null,
  walletDetails: null
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.RetrieveBitcoinAccountRequest:
      return handleRetrieveBitcoinAccountRequestAction(context, state, action);
    case ActionType.RetrieveBitcoinAccountResponse:
      return handleRetrieveBitcoinAccountResponseAction(context, state, action);
    default:
      return [state, null];
  }
};
const bitcoin = (seed, context) => {
  const w = workflow(update(context), seed);
  return {
    states: w.states,
    updates: w.updates,
    emit: w.emit
  };
};
export default bitcoin;